import React, { useState, useEffect, useRef } from 'react';
import { TContentHubSeriesDetailsProps } from '../types/productSeriesDetailFeature.types';
import ComponentDetails from './componentDetails';
import { SeriesDetailsModel } from '../models/productSeriesDetailFeature.model';
import { Element } from 'react-scroll';
import Slide from 'react-reveal/Slide';
import { googleClickTabEvent } from '../../../utils/analytics';
import { windowService } from '../../../utils/window.utils';
import { TComponentDetails } from '../types/productSeriesDetailFeature.types';
import { titleKeySeriesFeature } from '../../../constants/dictionary.constants';
import FeatureHeader from './featureHeader';
import useScrollWithShadow from '../../../hooks/useScrollWithShadow';
import useShowProductComponentTitle from '../../../hooks/useShowProductComponentTitle';
import Icon from '../../@shared/icon';
import { iconSize } from '../../../constants/icon.constants';

const DesktopSeriesDetails = (props: TContentHubSeriesDetailsProps): JSX.Element => {
  const model = new SeriesDetailsModel(props);
  const [componentArr, setComponentArr] = useState<TComponentDetails[]>([]);
  const { showShadowTop, showShadowBottom, scrollElementRef, onScrollHandler } = useScrollWithShadow();
  const [shadowWidth, setShadowWidth] = useState(0);
  const sectionRef = useRef<Element>(null);
  const hasTitile = !!model?.title;
  const showTitle = useShowProductComponentTitle(hasTitile, [titleKeySeriesFeature]);

  useEffect(() => {
    function handleResize() {
      const newShadowWidth = scrollElementRef?.current?.clientWidth || 0;
      setShadowWidth(newShadowWidth);
    }

    handleResize();
    windowService().addEventListener('resize', handleResize);
    return (): void => windowService().removeEventListener('resize', handleResize);
  }, [scrollElementRef]);

  const setImageWidth = () => {
    if (sectionRef?.current) {
      sectionRef?.current?.style.setProperty('--pfe-feature-image-Width', `${sectionRef?.current?.clientWidth}px`);
    }
  };

  useEffect(() => {
    if (model?.innerComponents?.length && model?.innerComponents[0]) {
      setComponentArr([model?.innerComponents[0]]);
    }
  }, [model.contextItemUrl]);

  useEffect(() => {
    setImageWidth();
  }, [sectionRef]);

  useEffect(() => {
    windowService()?.addEventListener('resize', setImageWidth);
    return () => {
      windowService()?.removeEventListener('resize', setImageWidth);
    };
  }, []);
  const automaticScrollTop = (event): void => {
    event.target?.parentElement?.scrollBy({
      top: -50,
      left: 0,
      behavior: 'smooth',
    });
  };

  const scrollDownOnClick = () => {
    scrollElementRef.current.scrollBy({
      top: 50,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Element name="Features">
      <section className="series-details">
        <div className="series-details__container">
          <div className="series-details__tabs-wrapper" onScroll={onScrollHandler} ref={scrollElementRef}>
            {showShadowTop && (
              <div
                className="series-details__shadow series-details__shadow-grey-top"
                style={{ width: shadowWidth }}
                onClick={automaticScrollTop}
              ></div>
            )}
            {showShadowBottom && (
              <div className="series-details__shadow-wrapper" style={{ width: shadowWidth }}>
                <div className="series-details__scroll-more-icon" onClick={scrollDownOnClick} style={{ width: shadowWidth }}>
                  <Icon iconName="arrow-head-down" size={iconSize.dsk} color='medium-gray' extraClassName='series-details__scroll-more-icon--pointer'/>
                </div>
              </div>
            )}
            {showTitle && <FeatureHeader title={model?.title} titleKeySeriesFeature={titleKeySeriesFeature} />}
            <ul className="series-details__tabs">
              {model?.innerComponents?.map((component, index) => (
                <li className="series-details__tab" key={component.id}>
                  <button
                    className={`series-details__tab-button ${
                      componentArr[componentArr.length - 1]?.id === component.id ? 'series-details__tab-button--selected' : ''
                    }`}
                    onClick={(): void => {
                      setComponentArr((data) => {
                        if (component.id !== data[data.length - 1]?.id) {
                          data.push(component);
                        }
                        if (data.length >= 3) {
                          return [...data.slice(1)];
                        }
                        return [...data];
                      });
                      googleClickTabEvent('Open', component?.eyebrow, index + 1);
                    }}
                  >
                    <h3>{component.eyebrow}</h3>
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <section className="series-details__component-section" ref={sectionRef}>
            {componentArr.length > 0 &&
              componentArr.map(
                (_) =>
                  _ && (
                    <Slide bottom duration={1000} key={`${_.id}}`}>
                      <div className="series-details__component-wrapper">
                        <ComponentDetails backgroundColor={model.backgroundColor} component={_} className="series-details__component" />
                      </div>
                    </Slide>
                  )
              )}
          </section>
        </div>
      </section>
    </Element>
  );
};

export default DesktopSeriesDetails;
